<template>
	<div>
		<div id="toptab">
		
			<div class="h_menu4">
				<!-- start h_menu4 -->
				<div class="header-left">
					<div>
						<!-- <a href="index.html"><img src="../assets/img/logo-2.png" alt="" width="64"></a> -->
						<router-link to="/index" class="header-left-logo">
							<img src="../assets/img/logo-2.png" alt="" width="64">
						</router-link>
					</div>
					<div class="header-left-text">
						<a class="toggleMenu" href="#">
							<img src="../assets/img/menu-icon.png" alt="">
						</a>
						<ul class="nav">
							<li><router-link to="/products"  class="scroll">产品</router-link></li>
							<li><a href="#services" class="scroll">服务</a></li>
							<li><a href="#work" class="scroll">优势</a></li>
							<li><a href="#pricing" class="scroll">价格</a></li>
							<li><router-link to="/newslist" class="scroll">新闻</router-link></li>
							<li><a href="#contact" class="scroll">联系</a></li>
						</ul>
					</div>
					<div class="clearfix"></div>
		
					<!--/script-for-sticky-nav-->
				</div>
				<div class="header-right">
					<ul>
						<!-- <li><a href="#"><span class="fb"> </span></a></li>-->
						<li><a href="#"><span class="twit"> </span></a></li>
						<li><a href="#"><span class="drbl"> </span></a></li>
						<!-- <li><a href="#"><span class="yt"> </span></a></li> -->
					</ul>
				</div>
				<div class="clearfix"></div>
			</div><!-- end h_menu4 -->
		
		</div>
		<div class="vis">
			
		</div>
	</div>
	
</template>
<script>
	import $ from 'jquery'

	export default {
		name: 'toptab',
		props: {
			msg: String
		},
		mounted() {
			var ww = document.body.clientWidth;
			console.log(ww)
			$(window).bind('resize orientationchange', function() {
				ww = document.body.clientWidth;
				adjustMenu();
			});

			// $(".scroll").click(function(event) {
			// 	console.log("clahc")
			// 	event.preventDefault();
			// 	$('html,body').animate({
			// 		scrollTop: $(this.hash).offset().top
			// 	}, 1000);
			// })

			$(".nav li a").click(function() {
				console.log(this)
				$(this).parent().addClass("active");
				$(this).parent().siblings().removeClass("active");
			});
			$(".toggleMenu").click(function(e) {
				e.preventDefault();
				$(this).toggleClass("active");
				$(".nav").toggle();
			});
			adjustMenu();

			function adjustMenu() {
				if (ww < 800) {
					console.log(ww)
					$(".toggleMenu").css("display", "inline-block");

					$(".nav li").css("display", "block")
					if (!$(".toggleMenu").hasClass("active")) {
						$(".nav").hide();
					} else {
						$(".nav").show();
					}
					$(".nav li").unbind('mouseenter mouseleave');
					$(".nav li a.parent").unbind('click').bind('click', function(e) {
						// must be attached to anchor element to prevent bubbling
						e.preventDefault();
						$(this).parent("li").toggleClass("hover");
					});
				} else if (ww >= 800) {
					$(".toggleMenu").css("display", "none");
					$(".nav li").css("display", "inline-block")
					$(".nav").show();
					$(".nav li").removeClass("hover");
					$(".nav li a").unbind('click');
					$(".nav li").unbind('mouseenter mouseleave').bind('mouseenter mouseleave', function() {
						// must be attached to li so that mouseleave is not triggered when hover over submenu
						$(this).toggleClass('hover');
					});
				}
			}
			// var navoffeset = $(".header-home").offset().top;
			// $(window).scroll(function() {
			// 	var scrollpos = $(window).scrollTop();
			// 	if (scrollpos >= navoffeset) {
			// 		$(".header-home").addClass("fixed");
			// 	} else {
			// 		$(".header-home").removeClass("fixed");
			// 	}
			// });

		}

	}
</script>

<style scoped>
	@import url("../assets/css/style.css");

	@import url("../assets/css/bootstrap.css");

	h3 {
		margin: 40px 0 0;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #42b983;
	}
	.h_menu4{
		background-color: #272727;
		
	}
	#toptab{
		height: 10%;
	}
	
</style>
//

